import { type CompositeProduct, ProductStatusFilter } from "types"

export const productStatusFilter = (product: CompositeProduct) =>
    product?.isVerified ? ProductStatusFilter.Verified : ProductStatusFilter.Unverified
